import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
import { ref, watch, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpendingFilterTabs',
    props: {
        tabs: {},
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedTabEl = ref(null);
        const containerEl = ref(null);
        function handleTabClick(key) {
            emit('update:modelValue', key);
            scrollSelectedIntoView();
        }
        function scrollSelectedIntoView() {
            nextTick(() => {
                const tab = selectedTabEl.value;
                const container = containerEl.value;
                if (!tab || !container)
                    return;
                const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;
                container.scrollTo({ left: tabCenter - container.offsetWidth / 2, behavior: 'smooth' });
            });
        }
        watch(() => props.modelValue, () => {
            scrollSelectedIntoView();
        });
        onMounted(() => {
            scrollSelectedIntoView();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "containerEl",
                ref: containerEl,
                class: "filter-tabs-container"
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: tab.key,
                        ref_for: true,
                        ref: el => { if (tab.key === _ctx.modelValue)
                            selectedTabEl.value = el; },
                        class: _normalizeClass(['filter-tab', { selected: _ctx.modelValue === tab.key }]),
                        onClick: ($event) => (handleTabClick(tab.key))
                    }, _toDisplayString(tab.label), 11, _hoisted_1));
                }), 128))
            ], 512));
        };
    }
});
